import { LitElement, html, nothing } from 'lit';
import 'Components/atoms/vm-button/vm-button';
import { customElement, property } from 'lit/decorators.js';
import Styles from './vm-video-related-content.scss';

@customElement('vm-video-related-content')
export class VmVideoRelatedContent extends LitElement {
    static override styles = Styles;

    @property({ type: String, attribute: 'section-title' }) sectionTitle = '';
    @property({ type: String, attribute: 'section-link' }) sectionLink = '';

    override render() {
        return html`
            <div class="vm-video-related-content">
                ${this.sectionTitle
                    ? html`<h4 class="vm-video-related-content__title">${this.sectionTitle}</h4>`
                    : nothing}
                <div class="vm-video-related-content__list">
                    <slot></slot>
                </div>
                ${this.sectionLink
                    ? html`<vm-button
                          variant="outline"
                          color-scheme="neutral"
                          class="vm-video-related-content__cta"
                          href=${this.sectionLink}
                      >
                          See all
                          <vm-icon-next name="arrow-narrow-right" slot="icon-trailing"></vm-icon-next>
                      </vm-button>`
                    : nothing}
            </div>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'vm-video-related-content': VmVideoRelatedContent;
    }
}
